import { useState as t, useEffect as o } from "react";
import r from "copy-to-clipboard";
export default function (n, i) {
  var u = t(!1),
      c = u[0],
      e = u[1],
      f = i && i.successDuration;
  return o(function () {
    if (c && f) {
      var t = setTimeout(function () {
        e(!1);
      }, f);
      return function () {
        clearTimeout(t);
      };
    }
  }, [c, f]), [c, function () {
    var t = r(n);
    e(t);
  }];
}